import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

export const useFeatureStore = defineStore("feature-store", {
  state: () => ({
    features: useLocalStorage("use-feature-store--features", {}),
  }),
  getters: {
    isFeatureEnabled: state => featureName => {
      return state.features[featureName]?.enabled ?? false;
    },
    isFeatureToggled: state => featureName => {
      const feature = state.features[featureName];
      if (!feature) {
        return false;
      }
      return feature.enabled !== feature.enabled_by_default;
    },
  },
  actions: {
    updateFeatureConfig(featureConfig) {
      const features = {};

      for (const featureName in featureConfig) {
        const remoteValue = featureConfig[featureName];
        const localValue = this.features[featureName];

        if (!localValue) {
          features[featureName] = remoteValue;
          continue;
        }

        if (localValue.toggled) {
          if (localValue.enabled === remoteValue.enabled) {
            features[featureName] = remoteValue;
          } else {
            features[featureName] = localValue;
          }
        } else {
          features[featureName] = remoteValue;
        }
      }

      this.features = features;
    },
    // Flip a feature on/off client-side (developer override). Marks it `toggled` so a later
    // updateFeatureConfig from the server keeps the local choice. Used by the dev perf HUD to
    // A/B the GPU builder overlay live. Reassigns `features` so the reactive ref propagates.
    setFeatureEnabled(featureName, enabled) {
      const current = this.features[featureName] || {};
      this.features = { ...this.features, [featureName]: { ...current, enabled, toggled: true } };
    },
  },
});
